<script setup lang="ts">
import { NXGDSTagIndicator } from '@nsftx/seven-nxg-design-system'
import { computed } from 'vue'

interface ShortcutItemProps {
  keys: string[]
  label?: string
  labelPosition?: 'start' | 'end'
}

const { label, keys, labelPosition = 'end' } = defineProps<ShortcutItemProps>()

const shortcutKeysClasses = computed(() => ({
  'ss-shortcut-keys ss-flex-center ss-gap-xs': true,
  'ss-shortcut-keys--reversed': labelPosition === 'start',
}))
</script>

<template>
  <div :class="shortcutKeysClasses">
    <div class="ss-flex-center ss-gap-3xs">
      <NXGDSTagIndicator v-for="key in keys" :key :label="key" variant="subtle" />
    </div>
    <p class="ss-shortcut-keys__label">
      {{ label }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
@use '@/styles/mixins' as mixins;

.ss-shortcut-keys {
  &__label {
    color: var(--nxgds-mapped-color-text-disabled);
    @include mixins.typography('label-regular');
  }

  &--reversed {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
}
</style>
